import { Deserializable, JsonObject, Serializable } from '@ktypes/models';

export class DisplayOption implements Deserializable<any, DisplayOption>, Serializable<JsonObject> {
  constructor(
    public id?: string,
    public text?: string,
    public appImage?: string,
    public appImageUrl?: string,
    public isSelected = false
  ) {}

  deserialize(input: any): DisplayOption {
    if (input == null) {
      return null;
    }
    this.id = input.id;
    this.text = input.text;
    this.appImage = input.appImage;
    this.appImageUrl = input.appImageUrl;
    this.isSelected = input.isSelected;
    return this;
  }

  serialize(): JsonObject {
    const json: JsonObject = {};
    json['id'] = this.id;
    json['text'] = this.text;
    json['appImage'] = this.appImage;
    json['appImageUrl'] = this.appImageUrl;
    json['isSelected'] = this.isSelected;
    return json;
  }
}
